module.exports = __webpack_public_path__ + "img/ring_y_o_0_null@2x.6415c4eb.png";